<template>
  <div class="claim-home" v-if="!claimedHomes || claimedHomes?.length < 1">
    <div class="sub">Understand your home’s value, uncover hidden savings, and build wealth.</div>
    <a class="btn primary small" :href="glb.appUrl + 'homeowner/'">Add a Home</a>
  </div>
  <div class="claimed-homes" v-else>
    <template v-for="(item, i) in claimedHomes">
      <a :key="i" :href="glb.appUrl + 'my-movoto/owned-homes/' + item.propertyId" v-if="i<2">
        <img loading="lazy" v-if="item.tnImgPath" :alt="item.geo.address"  class="img" :src="item.tnImgPath" />
        <mvtMapStatic loading="lazy" v-else-if="item?.geo && item?.geo.lat && item?.geo.lng"
            :key="item.propertyId"
            :cacheFirst="true"
            :lat="item.geo.lat"
            :lng="item.geo.lng"
            type="streetview"
            streetViewDefautType="satellite"
            :hideDefaultMarker="true"  />
        {{item.geo.address}}
      </a>
    </template>
    <span v-if="claimedHomes.length > 2">+ {{ claimedHomes.length - 2 }} more</span>
  </div>

</template>
<script>
import { mapGetters } from "vuex";
import mvtMapStatic from '@/common/components/mvtmapstatic/mvt-mapstatic.vue';
export default {
  name: 'mvtMenuClaimedHomes',
  emits: ['toggleMenu'],
  props: ['claimedHomes'],
  components: {
    mvtMapStatic,
  },
  computed:{
    ...mapGetters('glb', ['glb']),
  },
};
</script>